module.exports = __webpack_public_path__ + "img/scama.6496f6ef.svg";